import { Injectable } from '@angular/core';
import { DefaultService, BaseResponseDTO, Prefix} from '@psnb/psnb-api';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PowerSupplyPrefixService {
  
  constructor(private powerSupplyService: DefaultService) {
    this.getAllPrefixesFromService();
  }

  getAllPrefixesFromService() {
    return this.powerSupplyService.getAllPrefixes().pipe(map(result => result));
  }

  createPrefix(prefix: Prefix) {
    return this.powerSupplyService.createPrefix(prefix).pipe(map(result => result));
  }

  deletePrefix(id: number): Observable<BaseResponseDTO> {
    return this.powerSupplyService.deletePrefix(id).pipe(map(result => result));
  }

  updatePrefix(prefix: Prefix) {
    return this.powerSupplyService.updatePrefix(prefix).pipe(map(result => result));
  }
}
